import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/style/style.css";

Vue.use(Vuetify);

const themesColors = {
  red: "#FF546A",
  yellow: "#FFA100",
  purple: "#8241F9",
  blue: "#068EF1",
  cyan: "#00B8AF"
};

export default function(config) {
  const theme = config.theme;
  const themeColor =
    theme && themesColors[theme] ? themesColors[theme] : "#00B8AF";
  return new Vuetify({
    theme: {
      dark: false,
      options: {
        customProperties: true
      },
      themes: {
        light: {
          primary: themeColor,
          secondary: "#424242",
          accent: "#82B1FF",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
          background: "#FFFFFF"
        }
      }
    },

    icons: {
      iconfont: "mdi"
    }
  });
}
